<span class="container">
  <mat-icon>info</mat-icon>
  <span class="container__info">A curated feed of COVID-19 related twitter posts from verified scientist accounts and reputable news outlets and institutions. If you notice an account is missing or shouldn't be here, contact us at <a href="mailto:gadgetideas@reprintsdesk.zendesk.com">gadgetideas@reprintsdesk.zendesk.com</a>.</span>
</span>
<app-feed [view]="view"></app-feed>


